import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=loading, false=unauth, object=auth
    const [checked, setChecked] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setUser(false);
        } finally {
            setChecked(true);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    };

    const logout = async () => {
        // Best-effort server-side logout. We intentionally swallow errors here
        // (e.g. expired session → 401) because the user intent is to clear local
        // auth state, which we do unconditionally on the next line.
        try {
            await api.post("/auth/logout");
        } catch (err) {
            // Non-fatal: log for diagnostics, but never block the local sign-out.
            console.warn("Server logout failed (continuing with local sign-out):", err?.message || err);
        }
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, checked, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
